import React, { useState } from "react";
import Layout from "./common/Layout";
import "../css/accountPerson.scss";

const AccountPerson = () => {
  const [searchValue, setSearchValue] = useState("");
  const [showModal, setShowModal] = useState(false);

  // 处理查询
  const handleSearch = () => {
    setShowModal(true);
  };

  return (
    <Layout>
      <div className="account-person">
        {/* 页面标题 */}
        <div className="page-header">
          <h1>账户持有人管理</h1>
        </div>

        {/* 搜索区域 */}
        <div className="search-section">
          <input
            type="text"
            className="search-input"
            placeholder="持有人名称"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <button className="btn-primary" onClick={handleSearch}>
            查询
          </button>
          <button className="btn-secondary" onClick={handleSearch}>
            重置
          </button>
        </div>

        {/* 新增按钮 */}
        <div className="action-section">
          <button className="btn-add" onClick={handleSearch}>
            <span className="add-icon">+</span> 新增持有人
          </button>
        </div>

        {/* 表格 */}
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>主体姓名（名称）</th>
                <th>主体类型</th>
                <th>审核状态</th>
                <th>生效/失效</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="5">
                  <div className="empty-state">
                    <div className="empty-icon">
                      <img src="/home/m4.png" alt="暂无数据" />
                    </div>
                    <p className="empty-text">暂无数据</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* 未授权访问提示框 */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">🔒</div>
            <h2 className="modal-title">未授权访问</h2>
            <p className="modal-message">您还没有权限访问此功能</p>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default AccountPerson;
